import { Component, OnInit, ViewChild,ViewEncapsulation,TemplateRef } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective,BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { ProductsService } from '../../services/products.service';
import { ProductsPropertiesService } from '../../services/productProperties.service';
import { FilterUrlService } from '../../services/filter-url.service';
import { CodigosSernapescaService } from '../../services/codigos-sernapesca.service';

@Component({
  selector: 'productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ProductosComponent implements OnInit {
  @ViewChild(ModalDirective) lgModal: ModalDirective;
  public primeracarga:boolean;
  public load:number;
  public isopen:boolean;
  public alert:string;
  public data_list:any[];
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public item_to_update:number;
  public especies: any[];
  public codigos_sernapesca:any[];
  public estados: any[];
  public empaque1: any[];
  public empaque2: any[];
  public empaque3: any[];
  public presentacion1: any[];
  public presentacion2: any[];
  public compensado: any[];
  public glaciado: any[];
  public hidratacion : any[];
  public peso:any[];
  public calibre:any[];
  public bsmodalref:BsModalRef;
  public producto_eliminar:any;
  public settings = {
    columns:{
      code: { header: "Codigo", type:"text", filter: { visible:true }},
      description: { header: "Descripción", type:"text", filter: { visible:true } },
      group: { header: "Grupo", type:"text", filter: { visible:true }},
      // average:{header:"Promedio",type:"text",filter:{visible:true}}
    },
    actions:{
      edit: true,
      view: false,
      delete: false
    }
  };

  constructor(private _productsPropertiesService: ProductsPropertiesService,private _productsService: ProductsService,private _loaddata: LoadService, private _filter: FilterUrlService, private _sernapescaService:CodigosSernapescaService, private modalService:BsModalService ) {
    this.isopen = false;
    this.primeracarga = false;
    this.alert = "";
    this.especies = [];
    this.codigos_sernapesca = [];
    this.estados = [];
    this.empaque1 = [];
    this.empaque2 = [];
    this.empaque3 = [];
    this.presentacion1 = [];
    this.presentacion2 = [];
    this.compensado = [];
    this.glaciado = [];
    this.hidratacion  = [];
    this.peso = [];
    this.calibre = [];
    this.producto_eliminar = null;
  }

  ngOnInit() {
    this._loaddata.loadChange(15);
    this._filter.filterFirstLoad(this.settings);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'id': new FormControl("-1",Validators.required),
      'codigo': new FormControl('',Validators.required),
      'descripcion': new FormControl('',Validators.required),
      'grupo': new FormControl('',Validators.required),
      'especie':new FormControl(null,Validators.required),
      'estado':new FormControl(null,Validators.required),
      'empaque1':new FormControl(null,Validators.required),
      'empaque2':new FormControl(null,Validators.required),
      'empaque3':new FormControl(null,Validators.required),
      'compensado':new FormControl(null,Validators.required),
      'glaciado':new FormControl(null,Validators.required),
      'hidratacion':new FormControl(null,Validators.required),
      'presentacion1':new FormControl(null,Validators.required),
      'presentacion2':new FormControl(null,Validators.required),
      'peso':new FormControl(null,Validators.required),
      'calibre':new FormControl(null,Validators.required),
      'codigo_sernapesca':new FormControl(null, Validators.required),
      'promedio':new FormControl(null),

      // 'promedio':new FormControl(null,Validators.required),
    });
    this.loadProperties();
  }

  /**
  * carga el listado de propiedades
  */
  loadProperties():void{
    this._loaddata.loadChange(50);
    this.isopen = true;
    this.alert = 'Cargando propiedades.';

    this._productsService.getAllProperties().subscribe((response:any) => {
      for (let propiedad of response.data) {
        if(propiedad.attributes.property_type_id == 1){
          this.especies.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 2){
          this.estados.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 3){
          this.presentacion1.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 4){
          this.presentacion2.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 6){
          this.compensado.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 7){
          this.hidratacion.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 8){
          this.glaciado.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 9){
          this.empaque1.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 10){
          this.empaque2.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 11){
          this.peso.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 12){
          this.calibre.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
        else if(propiedad.attributes.property_type_id == 13){
          this.empaque3.push({nombre:propiedad.attributes.name,id:propiedad.id});
        }
      }
      this.loadCodigos_Sernapesca();

    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  loadDataFiltered(filters){
    this._loaddata.loadChange(50);
    this.isopen = true;
    this.alert = 'Cargando información.';

    this._productsService.getDataFiltered(filters)
    .subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        if(response.data.length == 0){
            this.alert = "No se encontraron resultados."
        }
        else{
            this.alert = "Carga Correcta."
        }
        this.isopen =true;
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        if(error.status == 0){
          this._loaddata.loadChange(100);
          this.alert = 'Busqueda sin resultados.';
          this.isopen =true;
          this.onClosedAutomatic();
        }
        else{
          this.showError(error.error.error);
        }
      }
    );
  }

  /**
  * Carga el listado de codigos de sernapesca con sus relaciones.
  */
  loadCodigos_Sernapesca(){
    this.alert = 'Cargando Códigos de Sernapesca';
    this.isopen = true;
    this._loaddata.loadChange(65);
    this._sernapescaService.getAll().subscribe((response:any)=>{
      this.codigos_sernapesca = response.data;
      //console.log("CODIGOS SERNAPESCA: ", this.codigos_sernapesca);
      this.alert = 'Códigos de Sernapesca Cargados';
      this.isopen = true;
      this._loaddata.loadChange(80);
      this.loadData();
    }, error =>{
      //console.log("No se han cargado los códigos de sernapesca: ", error.error.error);
    })

  }

  /**
  * Carga el listado de productos con sus relaciones.
  */
  loadData():void{
    this._loaddata.loadChange(90);
    this.isopen = true;
    this.alert = 'Cargando productos.';

    this._productsService.get().subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        //console.log("PRODUCTOS: ", this.data_list);
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.signupForm.valueChanges.subscribe(data=>{
          //console.log("formulario: ",data);
        });
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * Envia a la BD los datos del formulario.
  */
  saveForm():void{
    this.alert = "Creando Producto";
    this.isopen =true;
    this._loaddata.loadChange(40);

    let prov = this._productsService.transformData(this.signupForm.value);
    let prov2 = this._productsPropertiesService.transformData(this.signupForm.value);
    //console.log("PROV: ", prov);
    //console.log("PROV2: ",prov2);

    this._productsService.save(prov).subscribe(
      (response:any) =>{
        this._productsPropertiesService.save(prov2,response.id).subscribe(
          (response:any) =>{
            this._loaddata.loadChange(60);
            this.hideChildModal();
            this.loadData();
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * Envia a la BD los datos a actualizar.
  */
  updateForm():void{
    this.alert = "Actualizando producto.";
    this.isopen = true;
    this._loaddata.loadChange(35);

    let htmlbody = this._productsService.transformData(this.signupForm.value);
    let prov2 = this._productsPropertiesService.transformData(this.signupForm.value);
    let url = this.data_list[this.item_to_update]['links'].self;

    this._productsService.update(url, htmlbody).subscribe(
      data => {
        this._productsPropertiesService.save(prov2,this.data_list[this.item_to_update].id).subscribe(
          (response:any) =>{
            this._loaddata.loadChange(60);
            this.alert = "Elemento actualizado.";
            this.hideChildModal();
            this.loadData();
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * Elimina la fila seleccionada de la BD
  * @param  data id de la fila a eliminar
  */
  deleteItem(url):void{
    this.alert = "Eliminando producto.";
    this.isopen = true;
    this._loaddata.loadChange(35);
    this._productsService.delete(url).subscribe(
      (response:any) => {
        this._loaddata.loadChange(70);
        this.alert = "Elemento eliminado.";
        this.producto_eliminar = null;
        this.cerrarModalEliminar();
        this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }
  /**
  * Carga la información de una fila en el formulario.
  * @param  index Indice de la fila que se carga en el formulario.
  */
  showEditForm(index) {
    this.cleanForm();
    this.item_to_update = index;
    let item = this.data_list[index];
    //console.log(item);
    this.signupForm.patchValue({
      'id': item.id,
      'codigo': item.attributes.code,
      'descripcion': item.attributes.description,
      'grupo': item.attributes.group,
      'especie':(item.relationships.properties.data.length!=0?item.relationships.properties.data[0].id:null),
      'estado':(item.relationships.properties.data.length!=0?item.relationships.properties.data[1].id:null),
      'presentacion1':(item.relationships.properties.data.length!=0?item.relationships.properties.data[2].id:null),
      'presentacion2':(item.relationships.properties.data.length!=0?item.relationships.properties.data[3].id:null),
      'compensado':(item.relationships.properties.data.length!=0?item.relationships.properties.data[4].id:null),
      'hidratacion':(item.relationships.properties.data.length!=0?item.relationships.properties.data[5].id:null),
      'glaciado':(item.relationships.properties.data.length!=0?item.relationships.properties.data[6].id:null),
      'empaque1':(item.relationships.properties.data.length!=0?item.relationships.properties.data[7].id:null),
      'empaque2':(item.relationships.properties.data.length!=0?item.relationships.properties.data[8].id:null),
      'peso':(item.relationships.properties.data.length!=0?item.relationships.properties.data[9].id:null),
      'calibre':(item.relationships.properties.data.length!=0?item.relationships.properties.data[10].id:null),
      'empaque3':(item.relationships.properties.data.length!=0?item.relationships.properties.data[11].id:null),
      'codigo_sernapesca':(item.relationships.sp_code.data.length!=0?item.relationships.sp_code.data.id:null),
      'promedio':(item.attributes.average?item.attributes.average:null)
    });
    this.title = "Actualizar Producto";
    this.isNew = false;
    this.lgModal.show();
  }

  /**
  * Muestra el modal para crear o actualizar segun corresponda.
  * @param tipo si es crear o actualizar
  */
  showChildModal(tipo:string): void {
    this.title = "Crear Producto";
    this.isNew = true;
    this.lgModal.show();
  }

  /**
  * Cierra el modal
  */
  hideChildModal(): void {
    this.lgModal.hide();
    this.cleanForm();
  }

  /**
  * Cierra el mensaje de alerta.
  */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

  /**
  * Muestra un error
  * @param  msg mensaje del error
  */
  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
  }

  /**
  * Limpia el formulario para volver a utilizarlo.
  */
  cleanForm():void{
    this.signupForm.reset();
    this.signupForm = new FormGroup({
      'id': new FormControl("-1",Validators.required),
      'codigo': new FormControl('',Validators.required),
      'descripcion': new FormControl('',Validators.required),
      'grupo': new FormControl('',Validators.required),
      'especie':new FormControl(null,Validators.required),
      'estado':new FormControl(null,Validators.required),
      'empaque1':new FormControl(null,Validators.required),
      'empaque2':new FormControl(null,Validators.required),
      'empaque3':new FormControl(null,Validators.required),
      'compensado':new FormControl(null,Validators.required),
      'glaciado':new FormControl(null,Validators.required),
      'hidratacion':new FormControl(null,Validators.required),
      'presentacion1':new FormControl(null,Validators.required),
      'presentacion2':new FormControl(null,Validators.required),
      'peso':new FormControl(null,Validators.required),
      'calibre':new FormControl(null,Validators.required),
      'codigo_sernapesca':new FormControl(null,Validators.required),
      'promedio': new FormControl(null),
      // 'promedio': new FormControl(null,Validators.required),

    });
  }

  /**
  * Actualiza el listado por la paginacion
  * @param data nuevo listado o mensaje de error.
  */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }

  showDeleteModal(producto,template: TemplateRef<any>){
      this.producto_eliminar = this.data_list[producto.index];
      this.bsmodalref = this.modalService.show(template);
      //console.log("Producto a Eliminar: ", this.producto_eliminar);
  }

  cerrarModalEliminar(){
    this.producto_eliminar = null;
    this.bsmodalref.hide();
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/productos/productos.component.ts